import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import AppText from "../../Core/AppText/AppText";
import { useTranslation } from "react-i18next";

interface TabProps {
	text: string;
	route?: string;
	role?: "tab" | "filter";
	active?: boolean;
	action?: any;
	onBeforeAction?: () => void;
}

const Tab: React.FC<TabProps> = ({
	text,
	route,
	role,
	active: activeFilter,
	action,
	onBeforeAction,
}) => {
	const location = useLocation();
	const navigate = useNavigate();

	const { t } = useTranslation();

	const { pathname } = location;

	const navigateToRoute = () => {
		if (route) navigate(route);
	};

	return (
		<React.Fragment>
			{role === "filter" ? (
				<TabStyles
					onClick={() => {
						onBeforeAction && onBeforeAction();
						action();
					}}
					className={activeFilter ? "active" : ""}
				>
					<AppText
						weight="bold"
						color={activeFilter ? "buttonTextGray" : "actionBlue"}
						cursor="pointer"
						lineHeight={"100%"}
					>
						{t(text as any)}
					</AppText>
				</TabStyles>
			) : (
				<TabStyles
					onClick={() => {
						onBeforeAction && onBeforeAction();
						navigateToRoute();
					}}
					className={
						pathname.split("/").includes(text.toLowerCase().replace(/ |_/g, "-")) ? "active" : ""
					}
				>
					<AppText
						weight="bold"
						cursor="pointer"
						color={
							pathname.split("/").includes(text.toLowerCase().replace(/ |_/g, "-"))
								? "buttonTextGray"
								: "actionBlue"
						}
						lineClamp={1}
						lineHeight={"100%"}
					>
						{t(text as any)}
					</AppText>
				</TabStyles>
			)}
		</React.Fragment>
	);
};

export default Tab;

const TabStyles = styled.div`
	border: 1px solid #ddd;
	padding: 0.58rem 1.4375rem;
	width: fit-content;
	border-radius: 6.25rem;
	cursor: pointer;
	/* margin-right: 0.9375rem; */
	background: ${(props) => props.theme.colors.COLOR_WHITE};
	user-select: none;

	&.active {
		border-color: ${(props) => props.theme.colors.INPUT_BORDER_FOCUSED};
		outline: 3px solid #c6d4da5f;
	}
`;
